import React, { useEffect, useState } from 'react';

import { Button, Spin } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import { requestClub } from 'app/constants/club.constants';

import { joinClub, leaveClub } from '../components/BikeClubRequest';
import {
  joinBikerBed,
  leaveBikerBed,
} from '../../BikerBed/components/BikerBedRequest';

const ActionState = (props) => {
  const {
    isBikerBed,
    isMember,
    setIsMember,
    previewJson,
    userData,
    status,
    isLoggedIn,
    setCountFollowers,
    setCountMembers,
    countFollowers,
    countMembers,
    fetching,
    className,
  } = props;

  const getBikerBedAction = () => {
    if (previewJson.owner && previewJson.owner.id === userData.id) {
      return <FormattedMessage id="Owner" defaultMessage="Owner" />;
    }

    const Member = () => {
      return <FormattedMessage id="Subscriber" defaultMessage="Subscriber" />;
    };
    const notMember = () => {
      return <FormattedMessage id="Subscribe" defaultMessage="Subscribe" />;
    };
    switch (status) {
      case 1:
        return Member();
      default:
        return notMember();
    }
  };

  const getBikeCLubAction = () => {
    if (previewJson.owner && previewJson.owner.id === userData.id) {
      return <FormattedMessage id="Owner" defaultMessage="Owner" />;
    }

    const Member = () => {
      return <FormattedMessage id="Member" defaultMessage="Member" />;
    };

    const notMember = () => {
      return <FormattedMessage id="Join" defaultMessage="Join" />;
    };

    const activeRequest = () => {
      return (
        <FormattedMessage id="Cancel request" defaultMessage="Cancel request" />
      );
    };

    switch (status) {
      case requestClub.CONFIRMED:
        return Member();
      case requestClub.USER_REQUEST:
        return activeRequest();
      default:
        return notMember();
    }
  };

  const classCollectName = `addBtn ${className}`;
  return (
    <Button
      // type="primary"
      style={{ minWidth: 160 }}
      className={classCollectName}
      disabled={status === 1 || status === requestClub.CONFIRMED}
      onClick={() => {
        const isMembers = () => {
          return isMember !== 0 ? setIsMember(0) : setIsMember(1);
        };
        const count = () => {
          return isBikerBed
            ? isMember !== 0
              ? setCountFollowers(countFollowers)
              : setCountFollowers(countFollowers + 1)
            : isMember !== 0
            ? setCountMembers(countMembers)
            : setCountMembers(countMembers);
        };

        if (!isBikerBed) {
          if (isMember !== 0) {
            leaveClub(isLoggedIn, previewJson.id, () => {
              isMembers();
              count();
            });
          } else {
            joinClub(isLoggedIn, previewJson.id, () => {
              isMembers();
              count();
            });
          }
        } else {
          if (isMember !== 0) {
            leaveBikerBed(isLoggedIn, previewJson.id, () => {
              isMembers();
              count();
            });
          } else {
            joinBikerBed(isLoggedIn, previewJson.id, () => {
              isMembers();
              count();
            });
          }
        }
      }}
    >
      <span>
        {fetching ? (
          <Spin size="small" />
        ) : isBikerBed ? (
          getBikerBedAction()
        ) : (
          getBikeCLubAction()
        )}
      </span>
    </Button>
  );
};

export default ActionState;
